import { useAppRouter } from '@/common/route/useAppRouter';
import { timeUnits } from '@/common/utils/helpers';
import { validateFormat } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_LEAGUE } from '@/modules/league/router';
import { leagueService } from '@/services/league';
import { useVuelidate } from '@vuelidate/core';
import { maxValue, minValue, numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useLeagueAdd() {
    const router = useAppRouter();

    const model = reactive({
        timeUnit: 1,
        timeDuration: 1,
        game: 2,
        maxPlayer: 100,
        defaultPoint: 1000,
        penaltyPoint: -100,
        positionPoints: '',
        startTime: new Date()
    });

    const validations = {
        timeDuration: { required, numeric, min: minValue(1), max: maxValue(3200) },
        game: { required, numeric, min: minValue(0), max: maxValue(3200) },
        maxPlayer: { required, numeric, min: minValue(5), max: maxValue(200) },
        defaultPoint: { required, numeric, min: minValue(0), max: maxValue(3200) },
        penaltyPoint: { required, max: maxValue(0) },
        positionPoints: { format: validateFormat(/^\d+(;\d+)*$/) }
    };

    const v$ = useVuelidate(validations, model);

    const create = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () =>
            leagueService.item.create(
                model.timeUnit,
                model.timeDuration,
                model.game,
                model.maxPlayer,
                model.defaultPoint,
                model.penaltyPoint,
                model.positionPoints,
                model.startTime.getTime()
            ),
        onSuccess: () => router.push({ name: ROUTE_NAME_LEAGUE.INDEX })
    });

    return { model, v$, create, timeUnits };
}
